import api from './index'
import request from '@/utils/request'

/**
 * @description 导出门店员工列表
 */
export function exportUserAccountDetails (data) {
  return request({
    url: `${api.exportUserAccountDetails}`,
    method: 'post',
    data
  })
}
/**
 * @description 门店员工查询-/getUserAccountList
 */
export function getUserAccountList (data) {
  return request({
    url: `${api.getUserAccountList}`,
    method: 'post',
    data
  })
}
/**
 * @description 门店员工新增/编辑/启停 -/editUserAccount
 */
export function editUserAccount (data) {
  return request({
    url: `${api.editUserAccount}`,
    method: 'post',
    data
  })
}
/**
 * @description 可选角色列表查询 -/getAllRoleInfo
 */
export function getAllRoleInfo (data) {
  return request({
    url: `${api.getAllRoleInfo}`,
    method: 'post',
    data
  })
}
/**
 * @description 可关联门店列表查询 -/getAllRelateShopInfo
 */
export function getAllRelateShopInfo (data) {
  return request({
    url: `${api.getAllRelateShopInfo}`,
    method: 'post',
    data
  })
}
/**
 * @description 判断是否可更换手机号 -/checkNewPhone
 */
export function checkNewPhone (data) {
  return request({
    url: `${api.checkNewPhone}`,
    method: 'post',
    data
  })
}
/**
 * @description 删除员工账号 -/delUserAccount
 */
export function delUserAccount (params) {
  return request({
    url: `${api.delUserAccount}`,
    method: 'get',
    params
  })
}
/**
 * @description 门店员工详情-/getUserAccountDetail
 */
export function getUserAccountDetail (params) {
  return request({
    url: `${api.getUserAccountDetail}`,
    method: 'get',
    params
  })
}
/**
 * @description 新增-自定义角色
 */
export function addRole (params) {
  return request({
    url: `${api.addRole}`,
    method: 'get',
    params
  })
}
/**
 * @description 编辑-自定义角色
 */
export function modifRole (params) {
  return request({
    url: `${api.modifRole}`,
    method: 'get',
    params
  })
}
/**
 * @description 删除-自定义角色
 */
export function delRole (params) {
  return request({
    url: `${api.delRole}`,
    method: 'get',
    params
  })
}
/**
 * @description 查询-角色列表
 */
export function queryRole (data) {
  return request({
    url: `${api.queryRole}`,
    method: 'post',
    data
  })
}

/**
 * @description 查询-根据角色查询用户
 */
export function queryUserByRole (data) {
  return request({
    url: `${api.queryUserByRole}`,
    method: 'post',
    data
  })
}
/**
 * @description 权限设置-查询
 */
export function queryMenu (data) {
  return request({
    url: `${api.queryMenu}`,
    method: 'post',
    data
  })
}
/**
 * @description 权限设置-保存
 */
export function saveMenu (data) {
  return request({
    url: `${api.saveMenu}`,
    method: 'post',
    data
  })
}
